import React, { useState } from "react";
import UserInfo from "../../components/CheckoutComponent/UserInfo";
import PaymentInfo from "../../components/CheckoutComponent/PaymentInfo";
import Confirmation from "../../components/CheckoutComponent/Confirmation";
import { useNavigate } from "react-router-dom";
import StepperComponent from "../../components/Accounts/StepperComponent";
import styled from "styled-components";
import fipayFonts from "../../theme";
import { Title1 } from "../../components/CheckoutComponent/CheckoutComponent.styled";
import { Formik } from "formik";
import { userSection } from "./user-step";
import { useStore } from "@nanostores/react";
import { checkoutProduct } from "../../store/nanostore";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_ORDER } from "../../graphql/queries/checkout";

const CheckoutSteps = [
  { label: "User Information" },
  { label: "Payment Information" },
  { label: "Confirmation" },
];

const CheckoutPage = () => {
  const navigate = useNavigate();
  const [stepNumber, setStepNumber] = useState(0);
  const $checkoutProduct = useStore(checkoutProduct);
  const [createPaymentLinkOrder, { loading, error, data }] =
    useMutation(CREATE_ORDER);

  const handleNext = () => {
    if (stepNumber < CheckoutSteps.length - 1) {
      setStepNumber(stepNumber + 1);
    }
  };

  const handlePrevious = (index: number) => {
    setStepNumber(index);
  };

  const getStepContent = (stepNumber: number) => {
    const handleSubmit = (value: any) => {
      console.table(value);
    };
    switch (stepNumber) {
      case 0:
        return {
          ...userSection,
          content: <UserInfo handleNext={handleNext} />,
        };
      case 1:
        return {
          title: "Payment Information",
          content: <PaymentInfo handleNext={handleNext} price={0} />,
          initialValue: {},
          handleSubmit,
        };
      case 2:
        return {
          title: "Confirmation",
          content: <Confirmation />,
          initialValue: {},
          handleSubmit,
        };
      default:
        return { title: "", content: null, initialValue: {}, handleSubmit };
    }
  };

  const { title, content, initialValue, schema, handleSubmit } = getStepContent(
    stepNumber
  ) as any;

  return (
    <CheckoutRightSide>
      <Title1>{title}</Title1>
      <StepperComponent
        steps={CheckoutSteps}
        activeStep={stepNumber}
        onClick={handlePrevious}
      />
      <Formik
        initialValues={{
          ...(initialValue ?? {}),
          $checkoutProduct,
          paymentLinkId: $checkoutProduct?.paymentLink.id,
        }}
        onSubmit={async (values, formikHelpers) => {
          formikHelpers.setSubmitting?.(true);
          await handleSubmit(values, createPaymentLinkOrder);
          formikHelpers.setSubmitting?.(false);
          await handleNext();
        }}
        validationSchema={schema}
      >
        {() => content}
      </Formik>
    </CheckoutRightSide>
  );
};

export default CheckoutPage;

export const CheckoutRightSide = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 57%;
  max-width: 574px;
  padding: 1rem 0;
  margin: 0 auto;
  background: ${fipayFonts.colors.White};
  box-sizing: border-box;
  & > * {
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 574px;
    padding: 1rem 0;
    margin: 0 auto;
    background: ${fipayFonts.colors.White};
    box-sizing: border-box;
    & > * {
      box-sizing: border-box;
    }
  }
`;
